<template>
    <div class="language-dropdown" v-if="selectedLanguage">
      <button @click="toggleDropdown" class="d-flex btn-default">
        <img :src="`${publicPath}/img/rcp/icon/lang_icon.svg`" :alt="selectedLanguage.country_code" />
        <span class="label-input mx-1">{{ selectedLanguage.country_code }}</span>
        <img :src="`${publicPath}/img/rcp/icon/dropdown-icon.svg`" />
      </button>
      <div v-if="isDropdownOpen" class="dropdown-language-container">
        <div v-for="(value, key) in languages" :key="key" @click="changeLanguage(key)">
          <img :src="`${publicPath}/img/rcp${value.flag}`" :alt="value.label" />
          {{ value.label }}
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import configLanguage from '@/config/configLanguage.json'
  
  export default {
    data() {
      return {
        publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
        isDropdownOpen: false,
        languages: configLanguage[process.env.VUE_APP_ENVIRONMENT]?configLanguage[process.env.VUE_APP_ENVIRONMENT]:configLanguage['default'],
        selectedLanguage: {}
      };
    },
    methods: {
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        changeLanguage(langCode) {
            this.selectedLanguage = { code: langCode, ...this.languages[langCode] };
            this.isDropdownOpen = false;
            this.$emit('set-language', langCode);
        }
    },
    mounted(){
        const currentLang = localStorage.getItem("lang-key");
        
        if (this.languages[currentLang]) {
            this.selectedLanguage = this.languages[currentLang];
        } else {
            this.selectedLanguage = this.languages["en-EN"];
        }
    }
  };
  </script>
  
  <style>
  .language-dropdown {
    position: relative;
    display: inline-block;
  }
  
  .language-dropdown button {
    background: #fff;
    border: 1px solid #ddd;
    padding: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  
  .language-dropdown img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  
  .language-dropdown .dropdown-language-container {
    position: absolute;
    background: white;
    list-style: none;
    padding: 0;
    margin: 0;
    right: 0;
    top: 25px;
    border: 1px solid #ddd;
    width: 200px;
    z-index: 2;
    max-height: 230px;
    overflow: auto;
    box-shadow: 0px 0px 21px 0px #0000001A;
    border-radius: 18px;
  }
  
  .language-dropdown .dropdown-language-container>div {
    display: flex;
    align-items: center;
    padding: 10px;
    cursor: pointer;
  }
  
  .language-dropdown .dropdown-language-container>div:hover {
    background: #f0f0f0;
  }
  </style>
  